// extracted by mini-css-extract-plugin
module.exports = {"not_found":"__404_not_found___7Nqb","text":"__404_text__Yc20t","fade_in":"__404_fade_in__nrfaF"};